export enum TransactionType {
  CREDIT = 'CREDIT',
  TOPUP_S247 = 'TOPUP_S247',
  REFUND = 'REFUND',
  RE_TOPUP = 'RE_TOPUP',
  DEBIT = 'DEBIT',
  PAYMENT_S247 = 'PAYMENT_S247',
  TOPUP_HDBANK = 'TOPUP_HDBANK',
  PAYMENT = 'PAYMENT'
}